// extracted by mini-css-extract-plugin
module.exports = {"floatLabel":"FloatLabel_floatLabel__3Jrob","label":"FloatLabel_label__22ewC","labelFloat":"FloatLabel_labelFloat__1Y05u"};